module.exports = __webpack_public_path__ + "brandly360-sygnet.svg?ce7dbf3ef9fa84a0c19aa1237c8db149";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/brandly360-sygnet.svg
// module id = 972
// module chunks = 2